module.exports = __webpack_public_path__ + "img/kf_lxwm.6c7bdd25.png";